export const errorState = { loading: false, error: true, success: false }
